import type { BoardRole } from '../types/profile'

export const boardRoles: BoardRole[] = [
  {
    id: 'mpi',
    organisation: 'Materials Processing Institute',
    role: 'Board Chair · Audit & Risk Chair',
    tenure: 'Current',
    status: 'Current',
    summary:
      'Chairing the strategic transformation of the UK’s leading research and innovation centre for advanced materials, steel and decarbonisation.',
    impact: [
      'Led board-level strategic transformation and the shift toward green steel and industrial decarbonisation programmes.',
      'Directed CEO onboarding and executive succession, securing continuity through a period of significant change.',
      'Chaired Audit & Risk, strengthening financial controls and risk appetite across a complex grant and commercial funding base.',
      'Oversaw commercial growth of the Institute’s intellectual property portfolio and licensing pipeline.',
    ],
    tags: ['Chair', 'Audit & Risk', 'Net Zero', 'CEO Succession'],
  },
  {
    id: 'gardner',
    organisation: 'Gardner Aerospace Holdings',
    role: 'Non-Executive Observer',
    tenure: 'Current',
    status: 'Current',
    summary:
      'Board oversight of a global aerospace detailed-parts manufacturer operating across the UK, Europe, India and China.',
    impact: [
      'Provided independent oversight of a multi-continent manufacturing footprint spanning four regional operating hubs.',
      'Scrutinised supply chain restructuring and capacity rebalancing following sustained aerospace demand volatility.',
      'Advised on customer concentration risk and long-term contract governance with tier-one primes.',
    ],
    tags: ['Aerospace', 'Global Footprint', 'Supply Chain'],
  },
  {
    id: 'inogesis',
    organisation: 'Inogesis',
    role: 'Non-Executive Director',
    tenure: 'Current',
    status: 'Current',
    summary:
      'Governance leadership for the innovation partner bridging global corporates and high-growth technology start-ups.',
    impact: [
      'Led a full overhaul of the governance framework, board reporting and delegated authority structure.',
      'Shaped the corporate–startup innovation bridge model into a repeatable, governed commercial offer.',
      'Introduced board-level performance measures for partnership pipeline and conversion.',
    ],
    tags: ['Governance Overhaul', 'Innovation', 'Scale-up'],
  },
  {
    id: 'forgemasters',
    organisation: 'Sheffield Forgemasters',
    role: 'Chair — Employee Benefit Trust & Remuneration Committee',
    tenure: 'Previous',
    status: 'Previous',
    summary:
      'Central board role through the UK Ministry of Defence acquisition of a nationally strategic forging and casting capability.',
    impact: [
      'Played a key role in the transition to Ministry of Defence ownership, protecting sovereign defence capability.',
      'Chaired the Employee Benefit Trust through the change of control, safeguarding employee interests.',
      'Chaired the Remuneration Committee through CEO succession and executive reward realignment.',
    ],
    tags: ['MOD Acquisition', 'RemCo', 'Sovereign Capability'],
  },
  {
    id: 'wmg',
    organisation: 'Warwick Manufacturing Group (WMG)',
    role: 'Non-Executive Director',
    tenure: 'Previous',
    status: 'Previous',
    summary:
      'Non-executive oversight of one of the UK’s foremost applied research groups in electrification and future mobility.',
    impact: [
      'Governed major programmes in vehicle electrification and next-generation propulsion.',
      'Provided oversight of light rail innovation and the very light rail demonstrator programme.',
      'Contributed to governance of the UK Battery Industrialisation Centre (UKBIC).',
    ],
    tags: ['Electrification', 'UKBIC', 'Applied Research'],
  },
]
